import React, { useState, useEffect } from 'react'
import styles from '../CustomDomainModal.module.css'
import { OptionButton } from './SharedComponents'
import CTAButton from 'components/CTAButton/CTAButton'
import { domainErrorMessage } from '../../CustomDomainTable/index'
import { WIZARD } from '../constants/strings'
import GetDomain from './GetDomain'
import { Button, Spinner } from 'react-bootstrap'

const SetUpWizard = ({ formik, onNext, onPrevious, onSelectEntri, onFail, setActiveStep, showPayWall, modalData }) => {
  const [loading, setLoading] = useState(false)
  const { values } = formik

  const isRootDomain = !!!values.dnsAddress.subdomain

  const handleSetUpWithEntri = async () => {
    if (values.wizard.selected === 'yes') {
      setLoading(true)
      try {
        const { domain, token, cert, cfName } = values.dnsRecords.data
        onSelectEntri(domain, token, cert, cfName, isRootDomain, values.dnsRecords.data)
        setLoading(false)
      } catch (error) {
        setLoading(false)
        onFail(domainErrorMessage)
      }
    } else if (values.wizard.selected === 'no') {
      setLoading(false)
      onNext()
    }
  }

  useEffect(() => {
    if (values.wizard.selected === 'yes') {
      handleSetUpWithEntri()
    }
  }, [values.wizard.selected])

  const handleAddManually = () => {
    formik.setFieldValue('wizard.selected', 'no')
    setActiveStep(3)
  }

  return (
    <div className={styles.container}>
      {values.dnsAddress.selected === 'no' ? (
        <GetDomain
          formik={formik}
          onPrevious={onPrevious}
          onNext={onNext}
          setActiveStep={setActiveStep}
          onMessage={onFail}
          showPayWall={showPayWall}
        />
      ) : values.wizard.selected === 'yes' ? (
        <>
          <div className={styles.subHeading}>
            <div className={styles.title}>Automatic DNS Setup</div>
            <div className={styles.subTitle}>
              Follow the instructions in the secure box below to automatically connect your domain.
            </div>
          </div>

          <div className={styles.entriEmbeddedCon}>
            <div id="entri-container" className={styles.entriContainer}></div>
            <button type="button" className={styles.addManuallyFloatingBtn} onClick={handleAddManually}>
              Add manually instead
            </button>
          </div>

          <div className={`${styles.btnContainer}`}>
            <Button
              variant="outline-primary"
              onClick={() => {
                formik.setFieldValue('wizard.selected', null)
              }}
              size="small"
              showLeftArrow={true}
              showArrow={false}
              leftArrowClass={styles.backArrow}
            >
              Back
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className={styles.subHeading}>
            <div className={styles.title}>{WIZARD.SUBHEADING}</div>
            <div className={styles.subTitle}>{WIZARD.DESCRIPTION}</div>
          </div>
          <div className={styles.optionCon}>
            <OptionButton
              actionDesc={'Simple setup'}
              actionlabel={'Automatically'}
              selectOption={() => {
                formik.setFieldValue(`wizard.selected`, values.wizard.selected === 'yes' ? null : 'yes')
              }}
              active={values.wizard.selected === 'yes'}
            />
            <OptionButton
              actionDesc={'Advanced set-up'}
              actionlabel={'Manually'}
              selectOption={() => {
                formik.setFieldValue(`wizard.selected`, values.wizard.selected === 'no' ? null : 'no')
              }}
              active={values.wizard.selected === 'no'}
            />
          </div>
          <div className={`${styles.btnContainer}`}>
            <Button
              variant="outline-primary"
              onClick={onPrevious}
              size="small"
              showLeftArrow={true}
              showArrow={false}
              leftArrowClass={styles.backArrow}
            >
              Back
            </Button>
            <Button
              onClick={handleSetUpWithEntri}
              size="small"
              disabled={!values.wizard.selected}
              className={styles.forwardButton}
              loading={loading}
            >
              Next
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

export default SetUpWizard
